import { ResponseDataGet } from "../../../models/responseDataGet";
import { agroApi } from "../api";
import { EntSummaryData, SummaryDataApiResponse, SummaryDataFilter } from "../../../models/summarydataModels/summaryModels";

export const summaryDataApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getSummaryData: builder.query<ResponseDataGet<SummaryDataApiResponse>, SummaryDataFilter>({
      query: (params) => ({
        url: "/passport-ruar-ws/work-crop/get-all",
        method: "POST",
        body: JSON.stringify(params),
      }),
    }),
    getSummaryDataAnimal: builder.query<ResponseDataGet<SummaryDataApiResponse>, SummaryDataFilter>({
      query: (params) => ({
        url: "/passport-ruar-ws/work-livestock/get-all",
        method: "POST",
        body: JSON.stringify(params),
      }),
    }),

    getTotalCount: builder.query<ResponseDataGet<EntSummaryData>, Partial<SummaryDataFilter>>({
      query: (params) => ({
        url: "/passport-ruar-ws/farmer-and-work/count",
        method: "POST",
        body: JSON.stringify(params),
      }),
    }),

    getTotalCountAnimal: builder.query<ResponseDataGet<EntSummaryData>, Partial<SummaryDataFilter>>({
      query: (params) => ({
        url: "/passport-ruar-ws/farmer-and-work/livestock/count",
        method: "POST",
        body: JSON.stringify(params),
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetSummaryDataQuery,
  useGetTotalCountQuery,
  useGetTotalCountAnimalQuery,
  useGetSummaryDataAnimalQuery,
} = summaryDataApi;
